<div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 2%;">
        <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
            Print
        </button>
        <button type="button" mat-raised-button matTooltip="Download Excel sheet" class="btn btn-danger"
            (click)="exportexcel('Profit Loss Report')" style="margin-right: 10px;">
            Export
        </button>
        <button mat-dialog-close onclick="closeexp()" class="btn noPrint">Close</button>
    </div>

    <div class="container" id="print-section">
        <div class="wrapper">
            <!-- Header Section -->
            <div class="row rowborder hc px-5">
                <div class="common" style="font-size: large;">
                    <span>दिनांक : {{ getFormattedDate() }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span style="margin-right:90px">पृष्ठ क्र : 1</span>
                </div>
                <div class="common text-center" style="font-size: large;">
                    <span>हिंदुस्थान प्रकाशन संस्था</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>आय - व्यय पत्रक</span>
                </div>
                <div class="common text-right" style="font-size: large;">
                    <span>दिनांक पासून : {{ startDate | date: 'dd-MM-yyyy' }}</span>
                    <div style="margin-bottom: 10px;"></div>
                    <span>दिनांक पर्यंत : {{ endDate | date: 'dd-MM-yyyy' }}</span>
                </div>
            </div>

            <!-- Table Header -->
            <div class="row rowborder">
                <div class="col-4 ml-5"><span class="fw_600">तपशील</span></div>
                <div class="col-2" style="text-align: right;"><span class="fw_600">ऊप खाते बॅलन्स</span></div>
                <div class="col-2" style="text-align: right;"><span class="fw_600">खर्च</span></div>
                <div class="col-2 mr-5" style="text-align: right;"><span class="fw_600">जमा</span></div>
            </div>

            <!-- Expense Data -->
            <ng-container *ngFor="let group of expenseArray">
                <div *ngIf="group.total_final_amt && group.total_final_amt !== 0">
                    <div class="row">
                        <div class="col-4 ml-5 fw_600">{{ group.exp_name }}</div>
                        <div class="col-2"></div>
                        <div class="col-2" style="text-align: right;">
                            <span *ngIf="group.expenses?.length && group.total_final_amt < 0">
                                {{ (group.total_final_amt < 0 ? (group.total_final_amt * -1) :
                                    group.total_final_amt).toFixed(2) }} </span>
                        </div>
                        <div class="col-2 mr-5" style="text-align: right;">
                            <span *ngIf="group.expenses?.length && group.total_final_amt > 0">
                                {{ (group.total_final_amt).toFixed(2) }}
                            </span>
                        </div>
                    </div>

                    <!-- Sub-Expenses -->
                    <div *ngIf="group.expenses?.length > 1" class="sub-expenses">
                        <ng-container *ngFor="let item of group.expenses">
                            <div *ngIf="item.sub_exp_name && item.sub_exp_name.trim() !== ''" class="row sub-row">
                                <div class="col-4 ml-5" style="padding-left: 20px;">
                                    <span>-> {{ item.sub_exp_name }}</span>
                                </div>
                                <div class="col-2" style="text-align: right;">
                                    <span>{{ (item.final_amt).toFixed(2)}}</span>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-2 mr-5"></div>
                            </div>
                        </ng-container>
                    </div>

                </div>
            </ng-container>

            <!-- <hr> -->

            <!-- Net Result -->
            <div class="row rowborder">
                <div class="col-4 ml-5 fw_600">
                    <span>
                        {{ totalIncome >= totalExpenditure ? 'जमा जास्त' : 'खर्च जास्त' }}
                    </span>
                </div>
                <div class="col-2"></div>
                <div class="col-2 mr-5" style="text-align: right;">
                    <span *ngIf="totalIncome < totalExpenditure" class="fw_600">
                        {{ (totalExpenditure - totalIncome).toFixed(2) }}
                    </span>
                </div>
                <div class="col-2" style="text-align: right;">
                    <span *ngIf="totalIncome >= totalExpenditure" class="fw_600">
                        {{ (totalIncome - totalExpenditure).toFixed(2) }}
                    </span>
                </div>
            </div>


            <!-- Final Totals Row -->
            <div class="row rowborder">
                <div class="col-4 ml-5 fw_600">एकूण :</div>

                <!-- खर्च Column -->
                <div class="col-2" style="text-align: right;">
                    <span class="fw_600">
                        {{ (totalIncome > totalExpenditure
                        ? (totalExpenditure + (totalIncome - totalExpenditure))
                        : totalExpenditure).toFixed(2) }}
                    </span>
                </div>

                <!-- जमा Column -->
                <div class="col-2" style="text-align: right;">
                    <span class="fw_600">
                        {{ (totalExpenditure > totalIncome
                        ? (totalIncome + (totalExpenditure - totalIncome))
                        : totalIncome).toFixed(2) }}
                    </span>
                </div>
            </div>


        </div>
    </div>
</div>